   <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                    <h3>
                        <span class="odometer" data-count="15">00</span>
                        <span class="sign-icon">+</span>
                    </h3>
                    <p>Project Management</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                    <h3>
                        <span class="odometer" data-count="0">00</span>
                        <span class="sign-icon">+</span>
                    </h3>
                    <p>Learning</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                    <h3>
                        <span class="odometer" data-count="10">00</span>
                        <span class="sign-icon">+</span>
                    </h3>
                    <p>Value Engineering</p>
                </div>
            </div>
        </div>
    </div>
